import { Button, ButtonGroup, Stack  } from 'react-bootstrap';
import { deleteFile, deleteFiles, downloadFile, downloadFiles } from './../../apis/fileApi';

import { usePermissionContext } from '../../auth/AuthContext';
import { Archive, Download } from 'react-bootstrap-icons';

const DeleteFile  = ({rowProps, disable}) =>
{   
    const { hasRole } = usePermissionContext();
    const fileData = rowProps.data;
    const handleDeleteFile = async () => 
    {
        const response = await deleteFile(fileData.id)
        rowProps.node.data = response
            
        rowProps.gridRef.current.api.refreshCells({rowNodes: [rowProps.node], force: true, columnIds: ["state"]});
      
    }

    return  <Button name="archive" className="disabled-button button-table"  label="archive" disabled><Archive/></Button>
}

export const FileActions = (rowProps) => 
{
    const { hasRole } = usePermissionContext();

    const handleDownloadFile = async () => {
        await downloadFile(rowProps.data)
        
    }

    return(
        <ButtonGroup>
            <Button  disabled={false} name="download" className="jobAction button-table" label="download" onClick={handleDownloadFile}><Download/></Button>
            <DeleteFile rowProps={rowProps} disable={true}/>
        </ButtonGroup>
    )
}

export const BatchFileActions = ({gridRef}) =>{

    const { hasRole } = usePermissionContext();
    const handleBatchDownload = async () => {
        const selectedRows = gridRef.current.api.getSelectedRows(); 
        downloadFiles(selectedRows);
    }

    const handleBatchArchive = async () => {
        const selectedRows = gridRef.current.api.getSelectedRows();
        const response = await deleteFiles( selectedRows);
        gridRef.current.api.refreshInfiniteCache();
    }
    return(
        
        <Stack direction="horizontal" gap={1} className='action-stack'>
            <Button disabled={!hasRole('Admin')}  name="download" className="jobAction  button-table" label="download" onClick={handleBatchDownload}><Download/></Button>
            <Button disabled={!hasRole('Admin')} name="archive" className="jobAction  button-table" label="archive" onClick={handleBatchArchive}><Archive/></Button>
        </Stack>
        
    )
}